import React, { useEffect, useState } from 'react';
import BaseElement from './BaseElement';
import ShapeEditor from '../modals/ShapeEditor';

export default function ShapeElement({
  id,
  shape,
  position,
  size,
  style,
  zIndex,
  isSelected,
  onSelect,
  onMove,
  onResize,
  onUpdate,
  onDelete,
  onDuplicate,
  onZIndexChange,
  containerRef
}) {
  const [showEditor, setShowEditor] = useState(false);

  const handleUpdate = () => {
    setShowEditor(true);
  };

  // Sync editing state so the canvas can hide the center pencil overlay
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (showEditor) {
        window.__sbwEditingSelectedId = id;
        window.dispatchEvent(new CustomEvent('sbw:editing-change', { detail: { id, isOpen: true } }));
      } else if (window.__sbwEditingSelectedId === id) {
        window.__sbwEditingSelectedId = null;
        window.dispatchEvent(new CustomEvent('sbw:editing-change', { detail: { id, isOpen: false } }));
      }
    }
  }, [showEditor, id]);

  // Listen for global center-pencil edit requests
  useEffect(() => {
    const handler = (e) => {
      const targetId = e?.detail?.id;
      if (targetId === id) setShowEditor(true);
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('sbw:request-edit', handler);
      return () => window.removeEventListener('sbw:request-edit', handler);
    }
  }, [id]);

  // Fallback if a request ID was set before listener attached
  useEffect(() => {
    if (typeof window !== 'undefined' && window.__sbwEditRequestId === id) {
      window.__sbwEditRequestId = null;
      setShowEditor(true);
    }
  }, [id]);

  const handleZIndexChange = (elementId, newZIndex) => {
    console.log('[DIAGNOSE] ShapeElement.handleZIndexChange called:', {
      id,
      elementId,
      newZIndex,
      propZIndex: zIndex,
      onZIndexChangeExists: !!onZIndexChange,
      onZIndexChangeType: typeof onZIndexChange
    });
    
    if (onZIndexChange) {
      console.log('[DIAGNOSE] ShapeElement passing to parent:', {
        functionSignature: onZIndexChange.toString().slice(0, 100)
      });
      onZIndexChange(elementId, newZIndex);
    }
  };

  return (
    <>
      <BaseElement
        id={id}
        type="shape"
        position={position}
        size={size}
        zIndex={zIndex}
        isSelected={isSelected}
        onSelect={onSelect}
        onMove={onMove}
        onResize={onResize}
        onDelete={onDelete}
        onDuplicate={onDuplicate}
        onUpdate={handleUpdate}
        onZIndexChange={handleZIndexChange}
        containerRef={containerRef}
      >
        {shape === 'triangle' ? (
          <div
            className="w-full h-full relative"
            data-component-name="ShapeElement-Triangle"
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'transparent',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <div
                style={{
                  width: '0',
                  height: '0',
                  borderLeft: `${size.width / 2}px solid transparent`,
                  borderRight: `${size.width / 2}px solid transparent`,
                  borderBottom: `${size.height}px solid ${style.fill || '#000000'}`,
                  opacity: style.opacity,
                  position: 'absolute',
                  top: 0,
                  left: 0
                }}
              />
            </div>
          </div>
        ) : (
          <div
            className="w-full h-full"
            style={{
              backgroundColor: style.fill,
              opacity: style.opacity,
              borderRadius: shape === 'circle' ? '50%' : style.borderRadius
            }}
            data-component-name="ShapeElement"
          />
        )}
      </BaseElement>

      <ShapeEditor
        isOpen={showEditor}
        onClose={() => setShowEditor(false)}
        onSave={(updates) => {
          onUpdate?.(updates);
          setShowEditor(false);
        }}
      />
    </>
  );
}